"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const insta_1 = require("./insta");
const fielderror_1 = require("../fields/fielderror");
const permisos_1 = require("./permisos");
/**Componente lector de códigos QR */
class QRReader extends React.PureComponent {
    constructor(props) {
        super(props);
        this.ChecarPermisos = async () => {
            var cordova = window["cordova"];
            if (cordova) {
            }
            else {
                //Si la app no es de cordova, no requiere permisos:
                this.setState({ permiso: true });
            }
        };
        this.handleRefVideo = async (video) => {
            if (video == null) {
                //Desmontando
                await this.scanner.stop();
            }
            else {
                //Montando
                this.videoElement = video;
                let scanner = new insta_1.Instascan.Scanner({
                    video: video,
                    mirror: false,
                    scanPeriod: 8
                });
                this.scanner = scanner;
                scanner.addListener("scan", this.handleContent);
                try {
                    const cameras = await insta_1.Instascan.Camera.getCameras();
                    if (cameras.length > 0) {
                        //TODO: Selector de la camara
                        //Agarramos la ultima camara que en android es la camara de atras
                        const backCamera = cameras[cameras.length - 1];
                        await scanner.start(backCamera);
                        this.setState({ loading: false });
                    }
                    else {
                        throw new Error("No hay cámaras disponibles");
                    }
                }
                catch (error) {
                    this.setState({ error: "" + error, loading: false });
                }
            }
        };
        this.handleContent = (data) => {
            if (this.props.onChange) {
                this.props.onChange(data);
            }
        };
        this.state = { loading: true, permiso: false };
    }
    async componentWillMount() {
        //Checamos que la camara tenga permiso
        const permiso = await permisos_1.concederPermisoCamara();
        this.setState({ permiso: permiso });
    }
    render() {
        return (this.state.error ?
            React.createElement("div", { style: { color: "white" } },
                React.createElement("h4", null,
                    React.createElement("i", { className: "fa fa-ban fw" }),
                    " Uso de la c\u00E1mara no soportado en este dispositivo"),
                React.createElement(fielderror_1.FieldErrorView, { error: this.state.error })) :
            this.state.permiso ?
                React.createElement("video", { ref: this.handleRefVideo, style: this.props.style }) :
                React.createElement("div", null,
                    React.createElement("h4", null,
                        React.createElement("i", { className: "fa fa-ban fw" }),
                        "Otorgue permiso a la aplicaci\u00F3n de utilizar la c\u00E1mara")));
    }
}
exports.QRReader = QRReader;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/qr/reader.js
// module id = 510
// module chunks = 0